/* jp-set · "your set" from the prototype (R26b), on top of the engine's set (window.JPState).
   - add a library design straight into the set (sizes from the size contract, never retyped)
   - a design goes straight into the set (15 spaces until a bigger set is chosen in the cart: the set size is picked
     there, spec part 0 item 7); a design that does not fit offers the next pack or a smaller size
   - the set bar: last three designs, "N of 15 spaces" counting up, the drop filling with brand blue, View → Start;
     a design added from the page flies into it, or into the header's set ring while the bar is off (PROTO-2)
   - the sign-in nudge after the first add or save (guests), and the welcome card after signing in
   Writes only engine fields the engine itself writes for a library design (same shape as jp-p0-journey). */
(function () {
  'use strict';
  var ui = document.querySelector('[data-jp-setui]');
  if (!ui) return;
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.2,.8,.2,1)';
  var T = {};
  try { T = JSON.parse((document.querySelector('[data-jp-set-i18n]') || {}).textContent || '{}'); } catch (_) {}
  function t(key, vars) {
    var s = String(T[key] || '');
    Object.keys(vars || {}).forEach(function (k) { s = s.split('%' + k).join(String(vars[k])); });
    return s;
  }
  function pl(n, one, other) { return n + ' ' + (n === 1 ? one : other); }
  function $(sel, el) { return (el || ui).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || ui).querySelectorAll(sel)); }
  function store(k, v) { try { if (v === undefined) return window.localStorage.getItem(k); if (v === null) window.localStorage.removeItem(k); else window.localStorage.setItem(k, v); } catch (_) { return null; } }
  function sess(k, v) { try { if (v === undefined) return window.sessionStorage.getItem(k); if (v === null) window.sessionStorage.removeItem(k); else window.sessionStorage.setItem(k, v); } catch (_) { return null; } }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  /* ---------- sizes (size contract) ---------- */
  var SIZES = [];
  (function () {
    var tpl = document.querySelector('template[data-jp-sizes]');
    if (!tpl) return;
    Array.prototype.forEach.call(tpl.content.querySelectorAll('[data-jp-p0-size-id]'), function (b) {
      SIZES.push({ label: b.getAttribute('data-jp-p0-size'), id: b.getAttribute('data-jp-p0-size-id'), spaces: Number(b.getAttribute('data-jp-p0-spaces')) || 1, orientation: b.getAttribute('data-jp-p0-size-orientation') || 'portrait' });
    });
  })();
  function sizeFor(label) {
    var key = String(label || '').toUpperCase().replace(/\s+/g, ' ').trim();
    for (var i = 0; i < SIZES.length; i += 1) if (SIZES[i].label.toUpperCase() === key) return SIZES[i];
    return null;
  }

  /* ---------- engine state ---------- */
  function S() { return window.JPState ? window.JPState.read() : { items: [], plan: 'starter', saved: [] }; }
  function used(st) { st = st || S(); return window.JPState ? window.JPState.totalRequiredSpaces(st.items) : 0; }
  function plan(id) { return window.JPState ? window.JPState.getPlan(id || S().plan) : { id: 'starter', capacity: 15, priceLabel: '$19' }; }
  function cap(st) { return Number(plan((st || S()).plan).capacity) || 15; }
  function tiers() {
    var ids = window.JPState ? window.JPState.getPlanIds() : ['starter', 'core', 'large'];
    return ids.map(function (id) { var p = plan(id); return { id: id, cap: Number(p.capacity) || 0, price: p.priceLabel || '', cents: Number(p.priceCents) || 0 }; })
      .filter(function (x) { return x.cap > 0 && x.id === (plan(x.id).id || x.id); })
      .sort(function (a, b) { return a.cap - b.cap; });
  }

  /* ---------- toast ---------- */
  var toastEl = $('[data-toast]');
  function toast(msg) {
    if (!toastEl || !msg) return;
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('show'); }, 1800);   // PROTO-2 toast: 1.8 s
  }

  /* ---------- sheets ---------- */
  var scrim = $('[data-scrim]');
  var lastFocus = null;
  function openSheet(name) {
    var sh = $('[data-sheet="' + name + '"]');
    if (!sh) return;
    lastFocus = document.activeElement;
    scrim.classList.add('show');
    sh.classList.add('show');
    setTimeout(function () { try { sh.focus({ preventScroll: true }); } catch (_) {} }, 50);
  }
  function closeSheets() {
    scrim.classList.remove('show');
    $$('.jsheet.show').forEach(function (x) { x.classList.remove('show'); });
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (_) {}
  }
  scrim.addEventListener('click', closeSheets);
  $$('[data-sheet-close]').forEach(function (b) { b.addEventListener('click', closeSheets); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && $('.jsheet.show')) closeSheets(); });

  /* ---------- size sheet (prototype "Choose a size"): square / tall / wide, sizes from the size contract ---------- */
  function inches(label) {
    var m = String(label || '').match(/([\d.]+)\s*[×x]\s*([\d.]+)/);
    return m ? [parseFloat(m[1]), parseFloat(m[2])] : [0, 0];
  }
  function shape(label) { var d = inches(label); return d[0] === d[1] ? 'square' : (d[1] > d[0] ? 'tall' : 'wide'); }
  function group(label) {
    var g = shape(label);
    return SIZES.filter(function (z) { return shape(z.label) === g; }).sort(function (a, b) { var x = inches(a.label), y = inches(b.label); return (x[0] * x[1]) - (y[0] * y[1]) || a.spaces - b.spaces; });
  }
  function nice(label) { return String(label || '').replace(/ IN$/i, '\u00a0in').replace(/ × /g, '\u00a0×\u00a0'); }
  var sizeThen = null, sizeCur = '', sizeOri = 'square';
  function paintSize() {
    var oris = ['square', 'tall', 'wide'].filter(function (o) { return SIZES.some(function (z) { return shape(z.label) === o; }); });
    $('[data-size-oris]').innerHTML = oris.map(function (o) { return '<button class="chip' + (o === sizeOri ? ' on' : '') + '" type="button" aria-pressed="' + (o === sizeOri) + '" data-o="' + o + '">' + t('ori_' + o) + '</button>'; }).join('');
    var top = (tiers()[0] || { cap: 15 }).cap;
    $('[data-size-opts]').innerHTML = SIZES.filter(function (z) { return shape(z.label) === sizeOri; }).sort(function (a, b) { var x = inches(a.label), y = inches(b.label); return (x[0] * x[1]) - (y[0] * y[1]); }).map(function (z) {
      var need = z.spaces > top ? (tiers().filter(function (x) { return x.cap >= z.spaces; })[0] || {}).cap : 0;
      return '<button type="button" class="' + (z.label === sizeCur ? 'on' : '') + '" data-z="' + z.label + '"><b>' + nice(z.label) + '</b><span>' + pl(z.spaces, 'space', 'spaces') + (need ? ' · ' + t('needs', { n: need }) : '') + '</span></button>';
    }).join('');
  }
  function openSize(current, then) {
    sizeCur = String(current || '').toUpperCase(); sizeThen = then || null; sizeOri = shape(sizeCur || '1 × 1 IN');
    paintSize(); openSheet('size');
  }
  if ($('[data-size-oris]')) {
    $('[data-size-oris]').addEventListener('click', function (e) { var b = e.target.closest('[data-o]'); if (!b) return; sizeOri = b.getAttribute('data-o'); paintSize(); });
    $('[data-size-opts]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-z]'); if (!b) return;
      sizeCur = b.getAttribute('data-z'); paintSize();
      var fn = sizeThen; setTimeout(function () { closeSheets(); if (fn) fn(sizeFor(sizeCur)); }, calm ? 0 : 240);
    });
  }

  var pending = null, pickCap = 15, fullFor = null, fullPick = 'up';
  function openPick(needed, then) {
    pending = then || null;
    var ts = tiers();
    var first = ts.filter(function (x) { return x.cap >= (needed || 0); })[0];
    pickCap = (first || ts[ts.length - 1] || { cap: 15 }).cap;
    $('[data-pick-opts]').innerHTML = ts.map(function (x) {
      var dis = x.cap < (needed || 0);
      return '<button class="opt' + (x.cap === pickCap ? ' on' : '') + '" type="button" data-c="' + x.cap + '" data-id="' + x.id + '"' + (dis ? ' disabled' : '') + '><span><b>' + pl(x.cap, 'space', 'spaces') + '</b><span>' + t('tier', { n: Math.floor(x.cap / 3) }) + '</span></span><em>' + x.price + '</em></button>';
    }).join('');
    $('[data-pick-go]').textContent = t('pick_go', { cap: pickCap });
    openSheet('pick');
  }
  $('[data-pick-opts]').addEventListener('click', function (e) {
    var b = e.target.closest('.opt');
    if (!b || b.disabled) return;
    pickCap = +b.getAttribute('data-c');
    $$('[data-pick-opts] .opt').forEach(function (x) { x.classList.toggle('on', x === b); });
    $('[data-pick-go]').textContent = t('pick_go', { cap: pickCap });
  });
  $('[data-pick-go]').addEventListener('click', function () {
    var tier = tiers().filter(function (x) { return x.cap === pickCap; })[0];
    if (tier && window.JPState) window.JPState.setPlan(tier.id, 'set-pick');
    closeSheets();
    var p = pending; pending = null;
    if (p) setTimeout(p, calm ? 0 : 260);
    else { paint(true); toast(t('now_cap', { cap: pickCap, price: tier ? tier.price : '' })); }
  });

  function openFull(item, then) {
    fullFor = { item: item, then: then };
    var c = cap(), left = c - used(), need = item.spaces;
    var nx = tiers().filter(function (x) { return x.cap >= used() + need && x.cap > c; })[0];
    var cur = tiers().filter(function (x) { return x.cap === c; })[0];
    fullPick = nx ? 'up' : 'small';
    $('[data-full-h]').textContent = t('full_h', { n: need });
    $('[data-full-p]').textContent = t('full_p', { cap: c, left: left, name: item.title, size: item.sizeLabel.replace(' IN', ' in'), n: need });
    var diff = nx && cur ? '$' + Math.round((nx.cents - cur.cents) / 100) : '';
    $('[data-full-opts]').innerHTML = (nx ? '<button class="opt on" type="button" data-f="up" data-id="' + nx.id + '"><span><b>' + t('full_up', { cap: nx.cap }) + '</b><span>' + t('full_up_sub', { diff: diff }) + '</span></span><em>' + nx.price + '</em></button>' : '') +
      (left > 0 ? '<button class="opt' + (nx ? '' : ' on') + '" type="button" data-f="small"><span><b>' + t('full_small') + '</b><span>' + t('full_small_sub', { left: pl(left, 'space', 'spaces') }) + '</span></span></button>' : '');
    openSheet('full');
  }
  $('[data-full-opts]').addEventListener('click', function (e) {
    var b = e.target.closest('.opt'); if (!b) return;
    fullPick = b.getAttribute('data-f');
    $$('[data-full-opts] .opt').forEach(function (x) { x.classList.toggle('on', x === b); });
  });
  $('[data-full-go]').addEventListener('click', function () {
    closeSheets();
    if (!fullFor) return;
    var f = fullFor; fullFor = null;
    if (fullPick === 'up') {
      var b = $('[data-full-opts] .opt[data-f="up"]');
      if (b && window.JPState) window.JPState.setPlan(b.getAttribute('data-id'), 'set-full-up');
      setTimeout(f.then, calm ? 0 : 260);
    } else if (f.item && f.item.productHandle) {
      /* resize in the editor: the engine's own route for a library design */
      window.dispatchEvent(new CustomEvent('justpress:set-resize', { detail: { item: f.item } }));
      var editor = window.jpRoutes && window.jpRoutes.customPhoto;
      if (editor) {
        commit(f.item, null, true);
        window.location.assign(editor + (editor.indexOf('?') > -1 ? '&' : '?') + 'mode=image&item=' + encodeURIComponent(f.item.id) + '&return_to=' + encodeURIComponent(window.location.pathname));
      }
    }
  });

  /* ---------- add a library design ---------- */
  var lastSrc = null;
  function itemFromProduct(p, size) {
    size = size || sizeFor(p.sizeLabel) || sizeFor('2 × 3 IN') || { label: '2 × 3 IN', id: 'portrait-2x3', spaces: 3, orientation: 'portrait' };
    return {
      id: 'library-' + String(p.productId || p.id),
      productId: String(p.productId || p.id),
      productHandle: p.productHandle || '',
      designCode: p.designCode || '',
      title: p.title || '',
      style: p.style || '',
      description: p.description || '',
      image: p.image || '', previewImage: p.image || '', sourceUrl: p.image || '', previewUrl: p.image || '',
      minimumSizeIn: p.minimumSizeIn || null, minimumSizeStatus: p.minimumSizeStatus || '',
      artworkWidth: p.artworkWidth || null, artworkHeight: p.artworkHeight || null,
      sourceType: 'library', type: 'image', editorStatus: 'ready',
      sizeLabel: size.label, sizeId: size.id, spaces: size.spaces, orientation: size.orientation === 'landscape' ? 'landscape' : 'portrait',
      quantity: 1,
      editState: { x: 0, y: 0, zoom: 1, rotation: 0, fit: 'contain', erased: false }
    };
  }
  function commit(item, src, silent) {
    var before = S();
    var wasShown = bar && bar.classList.contains('show');
    if (!window.JPState) return false;
    var ok = window.JPState.update(function (next) {
      var i = next.items.findIndex(function (x) { return x.id === item.id; });
      if (i > -1) next.items[i] = Object.assign({}, next.items[i], item); else next.items.push(item);
      next.currentItemId = item.id;
      return next;
    }, 'set-add');
    if (!ok || silent) return ok;
    var st = S();
    document.dispatchEvent(new CustomEvent('justpress:set-added', { detail: { item: item, used: used(st), cap: cap(st) } }));
    if (src && !calm && (hideBar || (wasShown && getComputedStyle(bar).visibility === 'visible'))) fly(src, item.image);
    else paint(true);
    toast(t('added', { used: used(st), cap: cap(st) }));
    nudgeSoon('add');
    return ok;
  }
  function add(product, opts) {
    opts = opts || {};
    if (!window.JPState) return false;
    var item = itemFromProduct(product, opts.size);
    var st = S();
    if (st.items.some(function (x) { return x.productHandle && x.productHandle === item.productHandle; })) { toast(t('already')); return false; }
    var go = function () { add(product, opts); };
    if (used(st) + item.spaces > cap(st)) { openFull(item, go); return false; }
    return commit(item, opts.src || lastSrc);
  }

  /* ---------- set bar ---------- */
  var bar = $('[data-sb]');
  var hideBar = ui.getAttribute('data-hide-bar') === '1';
  var shown = null;
  /* ---------- a picture for any set item: the ONE helper every page that shows the set uses (JPSet.img) ----------
     img(item, done) -> a URL the page can show now, or '' (the caller keeps its neutral placeholder); done(url) is
     called when a picture read from this device is ready ('' when the device no longer has it), for every caller.
     - a saved URL (Shopify CDN / Files, a data: render) is used as it is;
     - a blob: URL is never used: it only lives as long as the page that made it, so one restored from the saved set
       is dead after a reload. Art and text made on this device are in JPLocalAssets (IndexedDB): the print file, else
       the original, is read again into a fresh object URL (the session preview while that runs);
     - the object URLs made here are revoked once no set item uses that file any more. */
  var pics = {};
  function keep(u) { return typeof u === 'string' && u && !/^blob:/i.test(u) ? u : ''; }
  function picKey(x) { return [x.localRenderAssetId, x.localAssetId].filter(Boolean).join('|'); }
  function readLocal(ids) {
    var A = window.JPLocalAssets;
    return (function next(i) {
      if (i >= ids.length) return Promise.resolve('');
      return Promise.resolve(A.get ? A.get(ids[i]) : null).then(function (r) {
        if (r && r.blob) return URL.createObjectURL(r.blob);
        return (A.preview && A.preview(ids[i])) || next(i + 1);
      }, function () { return next(i + 1); });
    })(0);
  }
  function itemImg(x, done) {
    if (!x) return '';
    var own = x.sourceType === 'upload' || x.sourceType === 'text';
    var direct = keep(x.renderUrl) || keep(x.previewUrl) || (own ? '' : keep(x.previewImage) || keep(x.image) || keep(x.sourceUrl));
    if (direct) return direct;
    var key = picKey(x), p = key && pics[key];
    if (p && p.ready) return p.url || keep(x.previewImage) || keep(x.image);
    if (key && window.JPLocalAssets) {
      if (!p) {
        p = pics[key] = { ready: false, url: '', wait: [] };
        readLocal(key.split('|')).then(function (u) {
          p.ready = true; p.url = u || '';
          var w = p.wait; p.wait = [];
          w.forEach(function (fn) { try { fn(p.url); } catch (e) { if (window.JPRuntime && JPRuntime.reportError) JPRuntime.reportError(e, 'set-img-callback'); } });
        });
      }
      if (done) p.wait.push(done);
      var A = window.JPLocalAssets;
      return (A.preview && (A.preview(x.localRenderAssetId) || A.preview(x.localAssetId))) || keep(x.previewImage) || keep(x.image);
    }
    return keep(x.previewImage) || keep(x.image);
  }
  /* revoke the object URLs of files no set item uses any more (an edit saved a new print file, a design was removed) */
  function sweepPics() {
    var live = {};
    S().items.forEach(function (x) { var k = picKey(x); if (k) live[k] = 1; });
    Object.keys(pics).forEach(function (k) {
      var p = pics[k];
      if (live[k] || !p.ready) return;
      if (/^blob:/.test(p.url)) try { URL.revokeObjectURL(p.url); } catch (e) {}
      delete pics[k];
    });
  }
  function thumbs(st) {
    return st.items.slice(-3).map(function (x) {
      var src = itemImg(x, function () { paint(false); });
      var q = function (s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); };
      return '<i>' + (src ? '<img src="' + q(src) + '" alt="' + q(x.title || 'Your design') + '">' : '') + '</i>';
    }).join('');
  }
  function tick(st) {
    var el = $('[data-sb-t]'), c = cap(st), to = used(st), from = shown === null ? to : shown;
    shown = to;
    if (calm || from === to || !bar.classList.contains('show')) { el.textContent = t('bar', { used: to, cap: c }); return; }
    var t0 = performance.now();
    (function step(now) {
      var k = Math.min(1, (now - t0) / 460), e = 1 - Math.pow(1 - k, 3);
      el.textContent = t('bar', { used: Math.round(from + (to - from) * e), cap: c });
      if (k < 1) requestAnimationFrame(step);
    })(t0);
  }
  function drop(st) {
    var lv = bar.querySelector('.lv'); if (!lv) return;
    var f = Math.min(1, used(st) / (cap(st) || 15));
    lv.style.transform = 'translateY(' + Math.round(761 - f * 729) + 'px)';
  }
  function paint(pop) {
    if (!bar) return;
    var st = S();
    var show = !hideBar && st.items.length > 0;
    bar.hidden = false;
    bar.classList.toggle('show', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    $('[data-sb-th]').innerHTML = thumbs(st);
    tick(st); drop(st);
    var tab = document.querySelector('.tabbar .tstart');
    if (tab) tab.classList.toggle('has', st.items.length > 0);
    if (pop && show && !calm && bar.animate) bar.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.02)' }, { transform: 'scale(1)' }], { duration: 360, easing: EASE });
  }
  function rectOf(img) {
    var r = img.getBoundingClientRect();
    var w = r.width, h = r.height, nw = img.naturalWidth || w, nh = img.naturalHeight || h, ar = nw / nh;
    if (img.tagName === 'IMG' && ar) { if (w / h > ar) w = h * ar; else h = w / ar; }
    return { x: r.left + (r.width - w) / 2, y: r.top + (r.height - h) / 2, w: w, h: h };
  }
  function fly(src, image) {
    paint(false);
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      var ring = hideBar ? document.getElementById('hsetBtn') : null;
      var th = ring && ring.getBoundingClientRect().width ? ring : $$('[data-sb-th] img').pop();
      if (!th || !src || !src.getBoundingClientRect) { paint(true); return; }
      var r0 = rectOf(src), r1 = rectOf(th);
      if (th !== ring) th.style.opacity = 0;
      var g = new Image(); g.className = 'jfly'; g.alt = ''; g.src = image || th.src;
      g.style.width = r1.w + 'px'; g.style.height = r1.h + 'px';
      if (th === ring) g.style.borderRadius = '50%';
      document.body.appendChild(g);
      function T(r) { return 'translate(' + r.x + 'px,' + r.y + 'px) scale(' + (r.w / r1.w) + ',' + (r.h / r1.h) + ')'; }
      var mid = { x: (r0.x + r1.x) / 2 + (r1.x > r0.x ? -30 : 30), y: Math.min(r0.y, r1.y) - 40, w: (r0.w + r1.w) / 2, h: (r0.h + r1.h) / 2 };
      var a = g.animate([{ transform: T(r0), opacity: 1 }, { transform: T(mid), opacity: 1, offset: 0.45 }, { transform: T(r1), opacity: 1 }], { duration: 620, easing: EASE, fill: 'both' });
      a.onfinish = function () {
        th.style.opacity = ''; g.remove();
        if (th !== ring) bar.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.025)' }, { transform: 'scale(1)' }], { duration: 320, easing: EASE });
      };
    }); });
  }
  document.addEventListener('pointerdown', function (e) {
    var b = e.target.closest('[data-jp-set-add], .add, .add2, [data-jp-p0-add-product]');
    if (!b) return;
    var host = b.closest('.pin, .pdv, .jpd-top, [data-jp-design-art]') || document;
    lastSrc = host.querySelector('.jpd-img, .phl img, img') || null;
  }, true);
  document.addEventListener('justpress:state-change', function () { paint(false); sweepPics(); });
  window.addEventListener('pageshow', function () { paint(false); });

  /* ---------- nudge (guests) ---------- */
  var nudge = $('[data-nudge]');
  function nudgeSoon(kind) {
    if (!nudge || ui.getAttribute('data-customer') === '1') return;
    if (sess('jp-nudge-snooze') || sess('jp-nudge-' + kind)) return;
    sess('jp-nudge-' + kind, '1');
    setTimeout(function () { showNudge(kind); }, kind === 'add' ? 2200 : 1600);
  }
  function showNudge(kind) {
    if (!nudge || !nudge.hidden || $('.jsheet.show') || sess('jp-nudge-snooze')) return;
    $('[data-nd-t]').textContent = t('nd_' + kind + '_t');
    $('[data-nd-p]').textContent = t('nd_' + kind + '_p');
    /* 2.5.0: sit above whatever is fixed to the bottom of this page (tab bar, the design page's buy bar) */
    var lift = 0;
    Array.prototype.forEach.call(document.querySelectorAll('body *'), function (e) {
      if (e === nudge || nudge.contains(e) || e.closest('.jsheet,.jscrim')) return;
      var cs = getComputedStyle(e); if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return;
      var r = e.getBoundingClientRect(); if (r.height && r.height < innerHeight / 2 && r.bottom >= innerHeight - 2) lift = Math.max(lift, innerHeight - r.top);
    });
    nudge.style.bottom = lift ? (lift + 12) + 'px' : '';
    nudge.hidden = false;
    if (!calm && nudge.animate) nudge.animate([{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'none' }], { duration: 380, easing: EASE });
    clearTimeout(nudge._t);
    nudge._t = setTimeout(function () { hideNudge(false); }, 14000);
  }
  function hideNudge(snooze) {
    if (!nudge) return;
    if (snooze) sess('jp-nudge-snooze', '1');
    if (nudge.hidden) return;
    clearTimeout(nudge._t);
    if (calm || !nudge.animate) { nudge.hidden = true; return; }
    nudge.animate([{ opacity: 1 }, { opacity: 0, transform: 'translateY(12px)' }], { duration: 240, easing: EASE }).onfinish = function () { nudge.hidden = true; };
  }
  $$('[data-nd-no]').forEach(function (b) { b.addEventListener('click', function () { hideNudge(true); }); });
  document.addEventListener('justpress:saved-change', function (e) {
    var d = e && e.detail;
    if (d && (d.saved === false || d.removed)) return;
    nudgeSoon('save');
  });

  /* ---------- sign-in and checkout: white hand-off screen; after sign-in, the welcome card on the way back ----------
     Every way out goes through here: sign-in links (click), sign-in asked for by the server while adding spaces or
     checking out (JPAuthReturn.handoff → justpress:auth-handoff) and the checkout buttons (justpress:checkout-handoff). */
  var welc = $('[data-welc]');
  function showGo(kind) {
    if (!welc || calm) return;
    var go = $('[data-wlgo]'), p = go.querySelector('p');
    if (p) p.textContent = kind === 'checkout' ? (T.opening_checkout || p.textContent) : (T.opening_signin || p.textContent);
    if (!welc.hidden && !go.hidden) return;
    welc.classList.remove('dim');
    go.hidden = false;
    $('[data-wlcard]').hidden = true;
    welc.hidden = false;
    if (welc.animate) go.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 220 });
    clearTimeout(welc._go);
    welc._go = setTimeout(function () { if (!go.hidden) welc.hidden = true; }, 10000);
  }
  function signinGo() {
    if (ui.getAttribute('data-customer') === '1') return;
    sess('jp-welcome', '1');
    hideNudge(false);
    showGo('signin');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-jp-signin], a[data-jp-account-return]')) signinGo();
  }, true);
  document.addEventListener('justpress:auth-handoff', signinGo);
  document.addEventListener('justpress:checkout-handoff', function () { showGo('checkout'); });
  window.addEventListener('pageshow', function (e) { if (e.persisted && welc && !$('[data-wlgo]').hidden) welc.hidden = true; });
  function closeWelc() {
    if (!welc || welc.hidden) return;
    clearTimeout(welc._t);
    var done = function () { welc.hidden = true; welc.classList.remove('dim'); };
    if (calm || !welc.animate) return done();
    welc.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 260 }).onfinish = done;
  }
  async function welcome() {
    if (!welc || ui.getAttribute('data-customer') !== '1' || sess('jp-welcome') !== '1') return;
    sess('jp-welcome', null);
    var st = S(), n = st.items.reduce(function (a, x) { return a + (Number(x.quantity) || 1); }, 0), sv = (st.saved || []).length;
    var balAttr = ui.getAttribute('data-balance'), bal = balAttr === null ? null : Number(balAttr) || 0;
    var s = $('[data-wl-s]');
    s.hidden = !(n || sv);
    s.textContent = n ? t('wl_set', { n: pl(n, 'design', 'designs') }) : (sv ? t('wl_saved', { n: pl(sv, 'saved design', 'saved designs') }) : '');
    var row = $('[data-wln]');
    row.hidden = bal === null;
    if (bal !== null) {
      $('[data-wl-u]').textContent = bal === 1 ? T.wl_spaces_one || 'space in your account' : T.wl_spaces_other || 'spaces in your account';
      $('[data-wl-n]').textContent = '0';
    }
    $('[data-wlgo]').hidden = true;
    var card = $('[data-wlcard]');
    card.hidden = false;
    welc.hidden = false;
    welc.classList.add('dim');
    if (!calm && card.animate) await card.animate([{ opacity: 0, transform: 'translateY(18px) scale(.97)' }, { opacity: 1, transform: 'none' }], { duration: 380, easing: EASE }).finished;
    if (bal !== null) {
      var t0 = performance.now();
      (function step() {
        var p = Math.min(1, (performance.now() - t0) / 1000), e = 1 - Math.pow(1 - p, 3);
        $('[data-wl-n]').textContent = Math.round(bal * e);
        if (p < 1) requestAnimationFrame(step);
      })();
    }
    welc._t = setTimeout(closeWelc, 3600);
  }
  if (welc) welc.addEventListener('click', function () { if ($('[data-wlgo]').hidden) closeWelc(); });

  function start() { paint(false); welcome(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  window.JPSet = {
    add: add, sizes: SIZES, sizeFor: sizeFor, used: used, cap: cap, tiers: tiers, plan: plan,
    toast: toast, img: itemImg, openPick: openPick, openSize: openSize, group: group, inches: inches, nice: nice, close: closeSheets, paint: paint, fly: fly, nudge: nudgeSoon,
    itemFromProduct: itemFromProduct, commit: commit, t: t
  };
})();

/* "+" on a design card (and any [data-jp-set-add]) adds straight into the set; ✓ once it is in */
(function () {
  'use strict';
  var OK = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function inSet() {
    var st = window.JPState ? window.JPState.read() : { items: [] };
    var h = {};
    st.items.forEach(function (x) { if (x.productHandle) h[x.productHandle] = 1; });
    return h;
  }
  function mark() {
    var h = inSet();
    Array.prototype.forEach.call(document.querySelectorAll('[data-jp-set-add]'), function (b) {
      var on = !!h[b.getAttribute('data-handle')];
      if (on === b.classList.contains('done')) return;
      b.classList.toggle('done', on);
      if (on) { b._plus = b._plus || b.innerHTML; b.innerHTML = OK; if (b._adding) { b._adding = false; b.classList.add('pop'); setTimeout(function () { b.classList.remove('pop'); }, 300); } }
      else if (b._plus) b.innerHTML = b._plus;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-jp-set-add]');
    if (!b || !window.JPSet || !window.JPState) return;
    e.preventDefault();
    if (b.classList.contains('done')) { window.JPSet.toast(window.JPSet.t('already')); return; }
    b._adding = true;
    var card = b.closest('.pin, [data-jp-set-host]') || b.parentNode;
    var src = card && card.querySelector('.phl img, img');
    window.JPSet.add({
      id: b.getAttribute('data-id'), productId: b.getAttribute('data-id'), productHandle: b.getAttribute('data-handle'),
      title: b.getAttribute('data-title'), image: b.getAttribute('data-image'), sizeLabel: b.getAttribute('data-size'),
      designCode: b.getAttribute('data-code'), style: b.getAttribute('data-style')
    }, { src: src });
  });
  document.addEventListener('justpress:state-change', mark);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark); else mark();
  if ('MutationObserver' in window) {
    var p = 0;
    new MutationObserver(function () { if (!p) p = requestAnimationFrame(function () { p = 0; mark(); }); }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
